// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { changeCustomerFulfillmentMethodStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerFulfillmentMethodSelector";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

changeCustomerFulfillmentMethodStyles.pickUpLocation = {
    ...changeCustomerFulfillmentMethodStyles.pickUpLocation,
    wrapper: {
        css: css`
            margin-top: 0;
        `,
    },
    headerText: {
        weight: fontConfig.weight.bold,
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
    },
    changeLink: {
        css: css`
            margin-left: 32px;
        `,
    },
    warehouseAddress: {
        wrapper: {
            css: css`
                margin-top: 12px;
            `,
        },
        nameText: {
            as: "p",
            size: fontConfig.fontSize.small,
            lineHeight: fontConfig.lineHeight.small,
        },
    },
};

changeCustomerFulfillmentMethodStyles.pickupLocationGridItem = {
    width: 12,
    css: css`
        &:empty {
            display: none;
        }
    `,
};

changeCustomerFulfillmentMethodStyles.container = {
    gap: 20,
};

changeCustomerFulfillmentMethodStyles.fulfillmentMethodRadioGroup = {
    ...{ horizontal: true },
    css: css`
        display: inline-block;
        & > ${TypographyStyle} {
            font-size: ${fontConfig.fontSize.regular}px;
            line-height: ${fontConfig.lineHeight.regular};
        }
        input:checked:not(:disabled) + label::after {
            top: 0;
        }
    `,
};
